import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export const CMS_TOKEN = new HttpContextToken<string | null>(() => null);

export class CMSTokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = req.context.get(CMS_TOKEN);
    if (token != null) {
      req = req.clone({ headers: req.headers.set('Authorization', `Token ${token}`) });
    }
    return next.handle(req);
  }
}
